import { z } from 'zod';

export const MyTelegramPathParamsSchema = z.object({ workspaceId: z.uuid() });

export const MyTelegramConnectionResponseSchema = z.object({
  available: z.boolean(),
  /** The bot's username without "@"; null when Telegram is not set up or `getMe` failed. */
  botUsername: z.string().nullable(),
  connection: z.object({ account: z.string(), connectedAt: z.iso.datetime() }).nullable(),
});
export type MyTelegramConnectionResponse = z.infer<typeof MyTelegramConnectionResponseSchema>;

export const IssueTelegramLinkCodeResponseSchema = z.object({
  code: z.string(),
  expiresAt: z.iso.datetime(),
  botUsername: z.string(),
});
export type IssueTelegramLinkCodeResponse = z.infer<typeof IssueTelegramLinkCodeResponseSchema>;
